import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.14,6.32a1.8,1.8,0,0,0-1.61-.24.25.25,0,0,0-.17.24v4.92a.5.5,0,1,1-1,0V4.74a1.77,1.77,0,0,0-.72-1.42A1.8,1.8,0,0,0,16,3.08a.25.25,0,0,0-.17.24V9.74a.5.5,0,1,1-1,0v-7A1.75,1.75,0,0,0,13.11,1a1.66,1.66,0,0,0-.59.1.25.25,0,0,0-.16.24V9.74a.5.5,0,1,1-1,0v-5a1.75,1.75,0,0,0-3.5,0v10a.26.26,0,0,1-.18.24.25.25,0,0,1-.28-.1l-2.12-3a1.73,1.73,0,1,0-2.82,2l5.47,7.72A3.22,3.22,0,0,0,10.58,23h5a6.25,6.25,0,0,0,6.25-6.25v-9A1.77,1.77,0,0,0,21.14,6.32Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }